<script setup>
import { useMetrics } from "@/composables/use.metrics";
import { onBeforeUnmount, onMounted, ref } from "vue";

const container = ref(null);
const sliderY = ref(0);
const { eventTypes, hitType, hit } = useMetrics();

const startDragging = (e) => {
  const moveHandler = (event) => {
    const clientY = event.touches ? event.touches[0].clientY : event.clientY;
    updateSlider(clientY);
  };

  const stopDragging = () => {
    window.removeEventListener("mousemove", moveHandler);
    window.removeEventListener("mouseup", stopDragging);
    window.removeEventListener("touchmove", moveHandler);
    window.removeEventListener("touchend", stopDragging);
  };

  window.addEventListener("mousemove", moveHandler);
  window.addEventListener("mouseup", stopDragging);
  window.addEventListener("touchmove", moveHandler, {passive: false});
  window.addEventListener("touchend", stopDragging);

  moveHandler(e);
};

const updateSlider = (clientY) => {
  const slider = container.value?.querySelector(".before-after-slider");
  if (!slider) return;

  const rect = slider.getBoundingClientRect();
  sliderY.value = Math.min(Math.max(clientY - rect.top, 0), rect.height);
};

const onScroll = () => {
  // ничего не делать — просто сохраняем sliderY в том виде, какой был
  // или — пересчитать, если высота блока динамически меняется:
  // updateCenter();
};

const updateCenter = () => {
  const slider = container.value?.querySelector(".before-after-slider");
  if (slider) {
    sliderY.value = slider.clientHeight / 2;
  }
};

onMounted(() => {
  window.addEventListener("scroll", onScroll, {passive: true});
  window.addEventListener("resize", updateCenter);
  updateCenter();
});


onBeforeUnmount(() => {
  window.removeEventListener("scroll", onScroll);
  window.removeEventListener("resize", updateCenter);
});

function run() {
  hit(eventTypes.FIREWORK, hitType.RUN_GAME_BANNER);
  document.dispatchEvent(new CustomEvent("run-win"));
}
</script>

<template>
  <div class="before-after-slider-wrapper vertical" ref="container">
    <div class="info">
      <p class="info__title">
        Создайте свой салют Победы в метавселенной ВДНХ!
      </p>
      <p class="info__text">
        Станьте частью доброй традиции и поздравьте близких с праздником!
      </p>
      <div class="info-block">
        <p class="info__text info__text--2">
          Подготовка праздничного салюта на Центральной аллее МетаВДНХ уже
          началась. Не хватает главного участника – режиссера! Решайте
          увлекательные головоломки и шаг за шагом создавайте свой уникальный
          салют в честь <br />
          80-летия Победы!
        </p>
        <img src="@/assets/9may/statue.svg" alt="" class="info__logo" />
      </div>
      <button class="link desk" @click="run">Начать</button>
    </div>
    <div class="before-after-slider-fill">
      <img src="@/assets/9may/tape.png" alt="" class="decoration" />
      <div class="before-after-slider">
        <img src="@/assets/9may/after.png" class="image" />
        <div class="before-image" :style="{height: sliderY + 'px'}"></div>
        <div class="divider" :style="{top: sliderY - 1 + 'px'}">
          <div class="divider-decoration"></div>
        </div>

        <svg
          class="n-resize-icon"
          viewBox="0 0 64 64"
          xmlns="http://www.w3.org/2000/svg">
          <polygon points="32,4 20,16 44,16" />
          <line x1="32" y1="16" x2="32" y2="48" />
          <polygon points="32,60 20,48 44,48" />
        </svg>
        <div
          class="drag-area"
          @mousedown="startDragging"
          @touchstart.prevent="startDragging"></div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.before-after-slider {
  position: relative;
  width: 100%;
  max-width: 100%;
  user-select: none;
  margin: 0 auto;
  border: 4px solid #fff;
  border-radius: 24px;
  overflow: hidden;
  height: 531px;
  &-wrapper {
    margin-top: 32px;
    position: relative;
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: space-between;
  }
  &-fill {
    position: relative;
    width: 100%;
    max-width: 678px;
    width: 100%;
  }
}
.info {
  width: 100%;
  max-width: 630px;
  &__title {
    font-weight: 700;
    font-size: 40px;
    line-height: 130%;
    letter-spacing: 0.01em;
    color: #fff;
  }
  &__text {
    margin-top: 10px;
    font-weight: 400;
    font-size: 24px;
    line-height: 130%;
    letter-spacing: 0.01em;
    color: #fff;
    &--2 {
      margin-top: 34px;
      max-width: 430px;
    }
  }
  &-block {
    display: flex;
    align-items: flex-start;
  }
  &__logo {
    width: 118px;
    position: relative;
    margin: 0 auto;
    display: flex;
    flex-shrink: 0;
  }
  @media (max-width: 1100px) {
    &__title {
      font-size: 24px;
    }
    &__text {
      margin-top: 12px;
      font-size: 14px;
      &--2 {
        margin-top: 12px;
      }
    }
    &-block {
      align-items: center;
    }
    &__logo {
      width: 70px;
    }
  }
  @media (max-width: 786px){
    &__text {
      br{
        display: none;
      }
    }
  }
}
.decoration {
  position: absolute;
  z-index: 11;
  top: 24px;
  right: -40px;
  transform: rotate(31deg);
}
.image {
  display: block;
  width: 100%;
  pointer-events: none;
  height: 100%;
}
.before-image {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background: url("@/assets/9may/before.png");
  background-repeat: no-repeat;
  background-size: 678px;
}
.divider {
  position: absolute;
  top: 0;
  width: 100%;
  background: #fff;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 15px;
  &-decoration {
    display: flex;
    flex-shrink: 0;
    border-radius: 14px;
    width: 27px;
    height: 66px;
    background: #fff;
    border: 8px solid #00288c;
    transform: rotate(90deg);
  }
}
.drag-area {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: ns-resize;
  z-index: 10;
  border-radius: 24px;
  overflow: hidden;
}

.n-resize-icon {
  width: 32px;
  height: 32px;
  stroke: #fff;
  stroke-width: 4;
  fill: none;
  position: absolute;
  top: calc(50% - 7px);
  right: 16px;
  animation: moveUpDown 3s ease-in-out infinite;
}
@keyframes moveUpDown {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.link {
  margin-top: 30px;
  max-width: 100%;
  border-radius: 2.12rem;
  width: 100%;
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 140%;
  color: #fff;
  background: #d72d41;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem;
}

@media (max-width: 1100px) {
  .before-after-slider {
    margin-top: 30px;
    min-height: 400px;
    border: 2px solid #fff;
    display: flex;
    &-wrapper {
      margin-top: 10px;
      flex-direction: column;
    }
  }
  .image {
    object-fit: cover;
  }
  .decoration {
    top: 43px;
    right: -61px;
    transform: rotate(31deg);
    width: 180px;
  }
  .link {
    padding: 0.8125rem 1.25rem;
    font-size: 14px;
    line-height: 140%;
    gap: 0.5rem;
    position: relative;
    z-index: 2;
  }
}
</style>
